// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"5ca0af85","498":"2bd4f2e8","513":"a7ff0614","703":"d13fd8dc"}[chunkId] + ".chunk.js";
};